import { FormControl, HStack, Header, Input, Text } from '@rbilabs/universal-components';

export const ContentHeader = Header.withConfig({
  marginY: '$3',
  marginX: 'auto',
});

export const StyledInput = Input.withConfig({
  marginRight: '$2',
  flex: 1,
});

export const StyledFormControl = FormControl.withConfig({
  flexDir: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
});

export const ErrorLabel = Text.withConfig({
  color: Styles.color.error,
  fontSize: 'xs',
});

export const InputWrapper = HStack.withConfig({
  width: 'full',
  justifyContent: 'space-between',
});
